import $ from 'jquery';
import 'bootstrap-sass';
import React from 'react';
import ReactDOM from 'react-dom';
import ModalFullScreenPicture from '../../../js/react/module/vehicleCondition/ModalFullScreenPicture';
import VehicleConditionManager from './vehicle-condition-manager';

const VEHICLE_CONDITION_LOADING_STATE_NOT_LOADED = 'not loaded';
const VEHICLE_CONDITION_LOADING_STATE_LOADING = 'loading';
const VEHICLE_CONDITION_LOADING_STATE_LOADED = 'loaded';

let defaults = [];
/** @type {{
 *     defaultId: string,
 *     downloaded: boolean|undefined,
 *     error: boolean|undefined,
 *     id: string,
 * }[]} */
let defaultsPictures = [];
let modalFullScreenPicture = null;
let renderedPictureIdx = null;
let selectedDefault = null;
let showPictureAsFullScreen = false;
let vehicleConditionLoadingState = VEHICLE_CONDITION_LOADING_STATE_NOT_LOADED;

/**
 * @param {string} id
 * @return {{}}
 */
function getDefaultWithId(id) {
    return defaults.find(element => (element.id === id));
}

/**
 * @param {string} id
 * @return {number}
 */
function getFirstPictureIndexOfDefault(id) {
    return defaultsPictures.findIndex(defaultPicture => (defaultPicture.defaultId === id));
}

function renderFullScreenPicture() {
    let nbPictures = 0;
    let picture = null;
    let pictureNumber = 0;

    if (showPictureAsFullScreen) {
        picture = defaultsPictures[renderedPictureIdx];

        if (selectedDefault) {
            nbPictures = selectedDefault.pictures.length;
            pictureNumber = renderedPictureIdx - getFirstPictureIndexOfDefault(selectedDefault.id) + 1;
        } else {
            nbPictures = defaultsPictures.length;
            pictureNumber = renderedPictureIdx + 1;
        }
    }

    ReactDOM.render(
        <ModalFullScreenPicture
            def={picture ? getDefaultWithId(picture.defaultId) : null}
            nbPictures={nbPictures}
            onClickNext={() => changePictureOfDefault(true)}
            onClickPrevious={() => changePictureOfDefault(false)}
            onHide={() => {
                renderedPictureIdx = null;
                selectedDefault = null;
                showPictureAsFullScreen = false;

                renderFullScreenPicture();
            }}
            picture={picture}
            pictureNumber={pictureNumber}
        />,
        modalFullScreenPicture,
    );
}

function handleShowAllDefaultsPictures() {
    renderedPictureIdx = 0;
    showPictureAsFullScreen = true;

    renderFullScreenPicture();
}

/**
 * @param {{
 *     defaultId: string,
 *     id: string,
 * }} picture
 * @return {void}
 */
function onPictureChange(picture) {
    const pictureId = picture.id;

    defaultsPictures = defaultsPictures.map(oldPicture => (
        (oldPicture.id === pictureId) ? { ...picture } : oldPicture
    ));

    renderFullScreenPicture();
}

/**
 * Changes the displayed picture of the default.
 *
 * @param {boolean} next True if we must display the next picture, false if we must display the previous picture.
 * @return {void}
 */
function changePictureOfDefault(next) {
    let firstIndex;
    let lastIndex;

    if (selectedDefault) {
        firstIndex = getFirstPictureIndexOfDefault(selectedDefault.id);
        lastIndex = firstIndex + selectedDefault.pictures.length - 1;
    } else {
        firstIndex = 0;
        lastIndex = defaultsPictures.length - 1;
    }

    renderedPictureIdx = next ? renderedPictureIdx + 1 : renderedPictureIdx - 1;

    if (renderedPictureIdx > lastIndex) {
        renderedPictureIdx = firstIndex;
    } else if (renderedPictureIdx < firstIndex) {
        renderedPictureIdx = lastIndex;
    }

    renderFullScreenPicture();
}

function handleShowDefaultPictures(defaultId) {
    renderedPictureIdx = getFirstPictureIndexOfDefault(defaultId);
    selectedDefault = getDefaultWithId(defaultId);
    showPictureAsFullScreen = true;

    renderFullScreenPicture();
}

$(document).ready(() => {
    $(document)
        .on('shown.bs.collapse', '#infoCondition', () => {
            if (vehicleConditionLoadingState === VEHICLE_CONDITION_LOADING_STATE_NOT_LOADED) {
                loadVehicleCondition();
            }
        })
        .on('hide.bs.collapse', () => {
            const $vehicleConditionLoadingError = $('#vehicle-condition-loading-error');

            if (!$vehicleConditionLoadingError.is(':hidden')) {
                $vehicleConditionLoadingError.fadeOut(() => {
                    $('#vehicle-condition-loading').fadeIn();
                });
            }
        });

    $(document).on(
        'click',
        '#infoCondition .default button.pictures',
        e => handleShowDefaultPictures($(e.target).closest('.default').data('id')),
    );

    $(document).on('click', '#view-all-defaults', handleShowAllDefaultsPictures);
});

/**
 * Charge l'état du véhicule
 *
 * @return {void}
 */
function loadVehicleCondition() {
    const $vehicleConditionContainer = $('#vehicle-condition-container');
    const id = $vehicleConditionContainer.data('id');

    vehicleConditionLoadingState = VEHICLE_CONDITION_LOADING_STATE_LOADING;

    VehicleConditionManager.getVehicleCondition(
        id,
        ({ html }) => {
            $vehicleConditionContainer.html(html);

            $('#vehicle-condition-loading').fadeOut(() => {
                $vehicleConditionContainer.fadeIn(() => {
                    const data = document.getElementById('data');

                    defaults = JSON.parse(data.dataset.defaults);
                    defaultsPictures = JSON.parse(data.dataset.defaultsPictures);
                    modalFullScreenPicture = document.getElementById('condition-content-modal-default-picture-full-screen');

                    data.remove();

                    VehicleConditionManager.downloadPictures(defaults, onPictureChange);

                    vehicleConditionLoadingState = VEHICLE_CONDITION_LOADING_STATE_LOADED;
                });
            });
        },
        () => {
            $('#vehicle-condition-loading').fadeOut(() => {
                $('#vehicle-condition-loading-error').fadeIn();
            });

            vehicleConditionLoadingState = VEHICLE_CONDITION_LOADING_STATE_NOT_LOADED;
        },
    );
}
